import { render, staticRenderFns } from "./ConcessionForm.vue?vue&type=template&id=5136aee0&"
import script from "./ConcessionForm.vue?vue&type=script&lang=js&"
export * from "./ConcessionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports